import React from 'react'
import "./assign.scss";
import { motion } from "framer-motion";
import Navbar from '../landing/header/Navbar';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Workflows from '../landing/workflows/Workflows';
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Headernew from '../landing/headernew/Headernew';
import ScheduleButton from '../landing/main-banner/ScheduleButton';
const Assign = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const cardVariants = {
        hidden: { opacity: 0, y: 40 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" },
        },
    };

    const options = {
        margin: window.innerWidth > 600 ? 20 : 10,
        loop: true,
        autoplay: window.innerWidth > 600 ? true : false,
        autoplayTimeout: window.innerWidth > 600 ? 2000 : null,
        autoplayHoverPause: window.innerWidth > 600 ? true : false,
        smartSpeed: 600,
        autoplaySpeed: 600,
        nav: true,
        dots: false,
        navText: [
            "<img src='/assets/left.svg'/>",
            "<img src='/assets/right.svg'/>",
        ],
        responsive: {
            0: { items: 1 },
            300: { items: 1.1 },
            400: { items: 1.1 },
            600: { items: 1.1 },
            1000: { items: 2.5 },
            1300: { items: 3.5 },
            1700: { items: 4.5 },
        },
    };

    const testimonials = [
        {
            name: "Holistic Network and Infrastructure Security Evaluation",
            quote:
                "Comprehensive assessments to identify and fortify vulnerabilities in your network and infrastructure.",
            img: "/assets/doone.svg",
        },
        {
            name: "Precise Application and System Vulnerability Scanning",
            quote:
                "Utilize cutting-edge tools and techniques for detailed vulnerability scanning across applications and systems, ensuring no weak points are left unchecked.",
            img: "/assets/dotwo.svg",
        },
        {
            name: "Swift Risk Identification and Strategic Mitigation Plans",
            quote:
                "Rapid identification of security risks followed by the development of strategic plans to mitigate these threats effectively.",
            img: "/assets/dothree.svg",
        },
        {
            name: "Tailored Security Posture Improvement Recommendations",
            quote:
                "Receive customized recommendations designed to enhance your overall security posture, aligning with your specific business needs.",
            img: "/assets/dofour.svg",
        },
        {
            name: "Rigorous Vulnerability Assessments and Penetration Testing",
            quote:
                "In-depth vulnerability assessments coupled with penetration testing to simulate cyber-attack scenarios and test the resilience of your security measures.",
            img: "/assets/dofour.svg",
        },
    ];

    const cardsData = [
        {
            title: "Continuous Security Monitoring",
            desc: "Stay ahead of threats with ongoing assessments and monitoring, ensuring your defenses remain robust against new vulnerabilities.",
            img: "/assets/paone.svg",
        },
        {
            title: "Expert Analysis and Insights",
            desc: "Leverage our team's expertise to gain deep insights into your security strengths and weaknesses, empowering you to make informed decisions.",
            img: "/assets/patwo.svg",
        },
        {
            title: "Proactive Threat Management",
            desc: "Our proactive approach ensures that potential security issues are identified and addressed before they can impact your operations.",
            img: "/assets/pathree.svg",
        },
        {
            title: "Peace of Mind",
            desc: "Enjoy the peace of mind that comes from knowing your organization is continuously protected by leading security experts.",
            img: "/assets/pafour.svg",
        },
        {
            title: "Cost-Effective Solution",
            desc: "Our subscription model offers a cost-effective solution to obtaining top-tier security assessments, saving you the expense of in-house resources or one-off consultations.",
            img: "/assets/pafive.svg",
        },
        {
            title: "Lorem Ipsum",
            desc: "Our subscription model offers a cost-effective solution to obtaining top-tier security assessments, saving you the expense of in-house resources or one-off consultations.",
            img: "/assets/pafive.svg",
        },
    ];


    return (
        <>
            <section className="main-banner security_main">
                <Headernew />
                <video
                    className="main-banner-video"
                    muted
                    playsInline
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo"
                >
                    <source src="/assets/bannervideo.mp4" type="video/mp4" />
                </video>

                <div className="custom-container1">
                    <div className="top_banner">
                        <motion.h3
                            initial={{ x: -100, opacity: 0 }}
                            whileInView={{ x: 0, opacity: 1 }}
                            viewport={{ once: false }} // 👈 animation runs every time on scroll
                            transition={{ duration: 1 }}
                        >
                            Security Assessments
                        </motion.h3>


                    </div>
                    <motion.h4
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        viewport={{ once: false }} // 👈 animation runs every time on scroll
                        transition={{ duration: 1 }}
                    >
                        <div className='elevate_mains lastauses'>
                            <h4>Secure Your Organization’s Future</h4>
                            <p>In today’s digital age, robust security measures are not just beneficial they are essential. Our Security Assessment subscriptions provides the expertise and insights you need to fortify your defenses, safeguard your digital assets, and maintain the trust of your stakeholders.
                            </p>


                        </div>
                    </motion.h4>

                </div>
            </section>
            <div className='marque_div'>
                <h3>Trusted By Clients Across Industries</h3>
                <div className="trendinganimations">
                    <div className="trendinganimationsright">
                        <div className="marquee">
                            <div className="marquee__group">
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\3.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\4.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\5.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\6.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\7.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\8.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\9.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\10.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>

                                <div>
                                    <img className='imgunder' src="\assets\11.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\12.png" />
                                </div>






                            </div>
                            <div aria-hidden="true" className="marquee__group">
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\3.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\4.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\5.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\6.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\7.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\8.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\9.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\10.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>

                                <div>
                                    <img className='imgunder' src="\assets\11.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\12.png" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='nnew_cardfss'>
                <div className='custom-container1'>

                    <div className='challenge'>
                        <h5>Common Security Assessment Challenges We Solve</h5>
                        <div className='eight_cards111'>
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Unidentified System Vulnerabilities</h6>
                                <p>Identify outdated software, misconfigurations, and unpatched risks.</p>
                            </div>
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Non-Compliance with Regulations</h6>
                                <p>Align with standards to avoid fines and protect reputation.</p>
                            </div>
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Inadequate Threat Simulation</h6>
                                <p>Test systems against realistic attacks to shore up defenses.</p>
                            </div>

                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Poor Risk Prioritization</h6>
                                <p>Filter security noise to focus on threats that matter most.</p>
                            </div>
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Reactive Security Posture</h6>
                                <p>Evolve beyond checklists to counter emerging threats.</p>
                            </div>

                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Lack of Actionable Reporting</h6>
                                <p>Provide clear insights that drive informed security investments.</p>
                            </div>


                        </div>
                        <h3>What if we could protect your apps, eliminate vulnerabilities, and simplify compliance<br></br>
                            so you stay secure without the stress?</h3>
                    </div>

                </div>

            </div>

            {/* <div className='nnew_cardfss'>
                <div className='custom-container1'>

                    <h5>Our Services Includes</h5>
                    <div className='eight_cards'>
                        <div>
                            <img src='\assets\onee.svg' />
                            <h6>Comprehensive Network & Infrastructure Security Evaluation</h6>
                        </div>
                        <div>
                            <img src='\assets\twoo.svg' />
                            <h6>Detailed Application & System Vulnerability Scans</h6>
                        </div>
                        <div>
                            <img src='\assets\threee.svg' />
                            <h6>Rapid Risk Identification & Mitigation Planning</h6>
                        </div>
                        <div>
                            <img src='\assets\fourr.svg' />
                            <h6>Customized Security Improvement Recommendations</h6>
                        </div>
                        <div>
                            <img src='\assets\ninee.svg' />
                            <h6>In-depth Vulnerability Assessments & Penetration Testing</h6>
                        </div>
                        <div>
                            <img src='\assets\fivee.svg' />
                            <h6>Continuous Security Monitoring & Updates</h6>
                        </div>
                        <div>
                            <img src='\assets\sixx.svg' />
                            <h6>Expert Analysis for Informed Security Decisions</h6>
                        </div>
                        <div>
                            <img src='\assets\sevenn.svg' />
                            <h6>Proactive Approach to Threat Management</h6>
                        </div>
                        <div>
                            <img src='\assets\eightt.svg' />
                            <h6>Cost-Effective, Expert-Led Security Solutions</h6>
                        </div>
                        <div>
                            <img src='\assets\tenn.svg' />
                            <h6>Continuous Protection for Your Digital Assets</h6>
                        </div>
                    </div>
                </div>

            </div> */}

            <section className="slider_Div lassst_div">



                <h5>What We Offer</h5>

                <div className="cardshead">
                    <OwlCarousel className="owl-theme" {...options}>
                        {testimonials.map((t, i) => (
                            <motion.div
                                key={i}
                                className="cards"
                                variants={cardVariants}
                                initial="visible"
                                whileInView="visible"
                                viewport={{ once: false, amount: 0.4 }} // replay on every scroll‑in
                            >
                                <img className="imgggg" src={t.img} alt={t.name} />                <h2>{t.name}</h2>
                                <h3>{t.title}</h3>
                                <p>“{t.quote}”</p>
                            </motion.div>
                        ))}
                    </OwlCarousel>
                </div>
            </section>


            <section className='secure_main1'>
                <img src='/assets/elipses.png' className='elipses' alt='background design' />
                <div className='custom-container1'>
                    <div className='inner_secure'>
                        <h3>Why Choose TechSecure360?
                        </h3>
                        <div className='parent_four_cards'>
                            {cardsData.map((card, index) => (
                                <motion.div
                                    className='onne_card'
                                    key={index}
                                    custom={index}
                                    variants={cardVariants}
                                    initial='hidden'
                                    whileInView='visible'
                                    viewport={{ once: false, amount: 0.3 }} // triggers on scroll in & out
                                >
                                    <div>
                                        <h4>{card.title}</h4>
                                        <p>{card.desc}</p>
                                    </div>
                                    <img src={card.img} alt={card.title} />
                                </motion.div>
                            ))}
                        </div>

                    </div>
                </div>
                {/* <p className='textdiv'>At TechSecure360, we are committed to helping organizations meet regulatory compliance requirements, strengthen their security measures, and effectively respond to security incidents. Contact us today to ensure your organization's security and regulatory needs are met with excellence.</p> */}
            </section>


            <div className='sub_mains'>
                <div className='custom-container1'>
                    <h3>Security Assessment Subscriptions</h3>

                    <div className='two_cardsmains'>
                        <div className='leftsidecards'>
                            <img src='\assets\shadee.png' className='shadeneww' />
                            <h4>Compliance Starter</h4>
                            <h5>$799/Month</h5>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Network & Infrastructure Security Evaluation (Basic)
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Application & System Vulnerability Scan (Quarterly)

                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Risk Identification & Basic Mitigation Planning
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Generic Security Improvement Recommendations
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Email Support for Security Inquiries
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Monthly Security Monitoring & Updates
                            </h6>

                            <Link to="/contactus">
                                <button className='bluebutton'>Contact Us</button>

                            </Link>

                        </div>

                        <div className='rightsidecards'>
                            <h4>Pro Package</h4>
                            <h5>$1399/Month</h5>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Comprehensive Network & Infrastructure Security Evaluations


                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Detailed Application & System Vulnerability Scans (Monthly)

                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Rapid Risk Identification & Advanced Mitigation Planning
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Customized Security Improvement Recommendations
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>In-depth Vulnerability Assessments & Penetration Testing

                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Continuous Security Monitoring & Updates
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Direct Access to Security Experts for Consultation
                            </h6>
                            <Link to="/contactus">
                                <button className='whitebutton'>Contact Us</button>
                            </Link>
                        </div>
                    </div>
                </div>

            </div>
            <section className='work_main'>
                {/* Background Shade Image */}
                <motion.img
                    src='/assets/shade.png'
                    className='imggshade'
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1 }}
                    viewport={{ once: false }}
                    alt='background shade'
                />

                {/* Background Video */}
                <motion.video
                    className='main-banner-video'
                    muted
                    playsInline
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 1.2 }}
                    viewport={{ once: false }}
                >
                    <source src="/assets/bottomvideo.mp4" type="video/mp4" />
                </motion.video>

                <div className='custom-container1'>
                    <motion.div
                        className='inner_work'
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: false }}
                    >
                        <h2>Ready to Modernize Your Workflows?</h2>

                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2, duration: 0.6 }}
                            viewport={{ once: false }}
                        >
                            Let’s talk about how we can secure and streamline your operations.
                        </motion.p>

                        <motion.div
                            className='buttons_div'
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.4, duration: 0.6 }}
                            viewport={{ once: false }}
                        >
                            <ScheduleButton />
                            {/* <button className='two'>Explore Portfolio</button> */}
                        </motion.div>
                    </motion.div>
                </div>
            </section>

        </>
    )
}

export default Assign
